import { BrowserAgent } from "@newrelic/browser-agent";
import flavours from "@/mixins/flavours";

const options = {
  loader_config: {
    accountID: "6771571",
    trustKey: "6771571",
    agentID: "538720690",
    licenseKey: "NRJS-fe6e263779ec1dd3f0d",
    applicationID: "538720690",
  },
  info: {
    beacon: "bam.eu01.nr-data.net",
    errorBeacon: "bam.eu01.nr-data.net",
    licenseKey: "NRJS-fe6e263779ec1dd3f0d",
    applicationID: "538720690",
    sa: 1,
  },
  init: { privacy: { cookies_enabled: true }, ajax: { deny_list: ["bam.eu01.nr-data.net"] } },
};

const agent = new BrowserAgent(options);
agent.wrapLogger(console, "info");
agent.wrapLogger(console, "error");
export default agent;
